module.exports = __webpack_public_path__ + "static/media/icon_box_white.db4c8b38.svg";